/* 🤖 this file was generated by svg-to-ts */
export const matIconHouseSiding: {
  name: 'house-siding';
  data: string;
} = {
  name: 'house-siding',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 12h3L12 3 2 12h3v8h2v-2h10v2h2v-8zM7.21 10h9.58l.21.19V12H7v-1.81l.21-.19zm7.36-2H9.43L12 5.69 14.57 8zM7 16v-2h10v2H7z"/></svg>`
};
